// extracted by mini-css-extract-plugin
module.exports = {"closeBox":"ChapterList__closeBox vertical-modal-list-close-box","root":"ChapterList__root vertical-modal-list--chapter-info"};
    if(module.hot) {
      // 1790535714227
      var cssReload = require("/var/lib/jenkins/workspace/Player_master/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  